export const renderCustomOrDefaultComp = (customRenderer, defaultRenderer, props) => {
  if (customRenderer && typeof customRenderer === 'function') return customRenderer(props);else return defaultRenderer(props);
};
//# sourceMappingURL=utils.js.map